import vars from '../../helpers';
import gsap from 'gsap';

const isDev = false;

function init(container) {
	return new Promise((resolve) => {
		const $site = container.querySelector('.site');
		const $prev = container.querySelector('.prev');

		if (vars.isMobile()) {
			document.documentElement.classList.remove('is-load');
			$site.classList.remove('is-load');

			resolve();

			return;
		}

		const tl = gsap.timeline({
			onComplete: resolve,
		});

		// disable animation for dev
		if (isDev) {
			document.documentElement.classList.remove('is-load');
			$site.classList.add('is-dev');

			resolve();

			return;
		}

		document.documentElement.classList.remove('is-load');
		$site.classList.remove('is-load');
		$site.classList.add('is-animate');
		vars.lockScroll(true, $('.site'));

		tl.add(
			gsap.from($prev, {
				y: '5%',
				duration: 3,
				ease: 'power2.inOut',
			}),
		);

		tl.add(
			gsap.to($prev, {
				y: 0,
				scale: 1,
				duration: 2,
				rotate: -360 * 2,
				ease: 'power2.inOut',
				clearProps: 'all',
				onComplete() {
					document.body.scrollTop = 0;
					$site.classList.remove('is-animate');

					if (!vars.getUrlPath()) {
						vars.lockScroll(false, $('.site'));
					}
				},
			}), '>0.5',
		);
	});
}

export default {
	init,
};
